import React, { createContext, useEffect, useState } from "react";
import Layout from "../../Layout";
import * as dateFns from "date-fns";
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import { enUS } from "date-fns/locale";
import "react-big-calendar/lib/css/react-big-calendar.css";
import EntityCalendarEvent from "./components/EntityCalendarEvent";
import styles from "./entity-calendar.module.scss";
import useEntityCalendar from "./useEntityCalendar";
import EntityCalendarToolbar from "./components/EntityCalendarToolbar";
import { useParams } from "react-router-dom";
import { Skeleton } from "primereact/skeleton";
import ReactCountryFlag from "react-country-flag";
import { getName } from "country-list";
import EventDetailCalander from "./components/EventDetailCalander";
import "./entity-calander.scss";
import EventList from "./components/EventList";
import CustomMultiSelectDropdown from "~/components/CustomMultiSelectDropdown";
import EventDetailCalenderPayrollPlus from "../MyCalendar/components/EventDetailCalenderPayrollPlus";

export const EntityContext = createContext();
const localizer = dateFnsLocalizer({ ...dateFns, locales: { "en-US": enUS } });
function EntityCalendar() {
  const {
    items,
    onDateChange,
    entity,
    calendarLoading,
    entityLoading,
    isOpen,
    formatDate,
    handleSelectEvent,
    eventDetail,
    handleCloseEventDetailCalander,
    showEventList,
    handleViewMoreEvent,
    sidebarBackBtn,
    selectedKeys,
    setSelectedKeys,
    filterOptions,
    chipData,
    handleRemoveFilter,
    handleChipData,
    setEventItems,
    fetchEvents,
    selectedEvents,
    handleSelectNode,
    taskSelected,
  } = useEntityCalendar();
  const { id } = useParams();

  const [toolbarButtonsWidth, setToolbarButtonsWidth] = useState(0);

  const handleApplyFilter = async () => {
    handleChipData(selectedKeys);
  };

  const handleDeSelect = () => {
    taskSelected.current = false;
    setSelectedKeys({});
    setEventItems([]);
    handleChipData({});
  };
  useEffect(() => {
    document.documentElement.style.setProperty(
      "--toolbar-right",
      `${toolbarButtonsWidth + 23}px`,
    );
  }, [toolbarButtonsWidth]);

  const EventComponentWrapper = ({ event }) => {
    const [visibleDates, setVisibleDates] = React.useState({});
    const dateKey = new Date(event.start).toDateString();

    const groupedEventsRef = React.useRef({});

    if (!groupedEventsRef.current[dateKey]) {
      groupedEventsRef.current[dateKey] = items
        .filter((e) => new Date(e.start).toDateString() === dateKey)
        .sort((a, b) => new Date(a.start) - new Date(b.start));
    }

    const groupedEvents = groupedEventsRef.current[dateKey];
    const isVisible = visibleDates[dateKey];
    const visibleEvents = groupedEvents.slice(0, 2);
    const hiddenCount = event.totalCount - visibleEvents.length;

    if (groupedEvents[0].id !== event.id) return null;

    const showMoreHandler = async () => {
      setVisibleDates((prev) => ({ ...prev, [dateKey]: true }));
      const date = new Date(dateKey);
      delete selectedKeys["Event Type"];
      const keys = Object.keys(selectedKeys || {});
      await fetchEvents({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
        filter: keys,
      });
      handleViewMoreEvent();
    };

    return (
      <div className={styles["events-wrapper"]}>
        {visibleEvents.map((e) => (
          <EntityCalendarEvent
            key={e.id}
            {...e}
            handleSelectEvent={handleSelectEvent}
          />
        ))}
        {!isVisible && hiddenCount > 0 && (
          <p className={styles["show-more"]} onClick={showMoreHandler}>
            +{hiddenCount} View more
          </p>
        )}
      </div>
    );
  };
  return (
    <EntityContext.Provider value={{ entity }}>
      <Layout
        title="Entity Calendar"
        crumbs={[
          { label: "My Entities", url: "/entities", id: "entities" },
          {
            label: entityLoading ? (
              <Skeleton width="100px" height="20px" className="mr-1" />
            ) : (
              <div className="flex gap-2">
                {entity?.name}
                <ReactCountryFlag
                  countryCode={entity?.country || ""}
                  svg
                  className=""
                />
                {getName(entity?.country || "")}
              </div>
            ),
            id: "entity",
            url: `/entity/${id}/dashboard`,
          },
          { label: "Entity Calendar", id: "entity-calendar" },
        ]}
        toggle={isOpen}
        overlap={true}
        SideNavSection={() => {
          return showEventList ? (
            <EventList
              events={selectedEvents}
              entity={entity}
              handleSelectEvent={handleSelectEvent}
              handleCloseEventDetailCalander={handleCloseEventDetailCalander}
            />
          ) : eventDetail?.label === "Payroll +" ? (
            <EventDetailCalenderPayrollPlus
              eventDetail={eventDetail}
              handleCloseEventDetailCalander={handleCloseEventDetailCalander}
              backBtn={sidebarBackBtn}
              handleViewMoreEvent={() => {
                handleViewMoreEvent();
              }}
            />
          ) : (
            <EventDetailCalander
              entity={entity}
              eventDetail={eventDetail}
              formatDate={formatDate}
              handleCloseEventDetailCalander={handleCloseEventDetailCalander}
              backBtn={sidebarBackBtn}
              handleViewMoreEvent={() => {
                handleViewMoreEvent();
              }}
            />
          );
        }}
      >
        <div className="entity-calendar-sheet">
          <div className="calendar-wrapper">
            <div className="filter-container">
              <CustomMultiSelectDropdown
                groupedOptions={filterOptions}
                value={selectedKeys}
                onChange={(e) => {
                  handleSelectNode(e.value);
                }}
                applyFilter={handleApplyFilter}
                deSelectAll={handleDeSelect}
                placeholder="All events"
              />
              <p className="calender-filter">Filter By</p>
            </div>
            <Calendar
              localizer={localizer}
              events={items}
              startAccessor="start"
              endAccessor="end"
              selectable
              className={styles.calendar}
              onNavigate={onDateChange}
              components={{
                event: EventComponentWrapper,
                toolbar: (props) => (
                  <EntityCalendarToolbar
                    {...props}
                    onWidthCalculated={setToolbarButtonsWidth}
                    loading={calendarLoading}
                    chipData={chipData}
                    handleRemoveFilter={handleRemoveFilter}
                  />
                ),
              }}
            />
          </div>
        </div>
      </Layout>
    </EntityContext.Provider>
  );
}

export default EntityCalendar;
